import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  Label,
  FormGroup,
  Button,
  Alert,
  CardTitle,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Drawer, Switch, Input as AntdInput, Select, InputNumber, Form as AntdForm } from "antd"
import {
  deleteVideoClient,
  updateVideoClient,
  updateVideoRoom,
  videoForceRefresh,
  videoGetClientStatus,
} from "helpers/backend_helper"
import * as Yup from "yup"
import { useFormik } from "formik"
import { showToast } from "utils/general"
import withRouter from "components/Common/withRouter"
import SelectOrder from "components/DropdownList/SelectOrder"
const { TextArea } = AntdInput;

const VideoRoomDrawer = props => {
  const [clientError, setClientError] = useState("")
  const [clientSuccess, setClientSuccess] = useState("")
  const [clientUpdate, setClientUpdate] = useState(false)

  const [updateError, setUpdateError] = useState("")
  const [updateSuccess, setUpdateSuccess] = useState("")
  const [update, setUpdate] = useState(false)
  const [refreshOngoing, setRefreshOngoing] = useState(false)
  const [statusOngoing, setStatusOngoing] = useState(false)

  const [deleteModal, setDeleteModal] = useState(false)
  const [ongoingDelete, setOngoingDelete] = useState(false)

  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  // Update client validation
  const clientValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      roomName: props.selectedRow?.roomName || "",
      newClientName: props.selectedRow?.clientName || "",
      newClientPassword: "",
      callRequestTimeout: props.selectedRow?.callRequestTimeout || "121",
      idleDisplayMode: props.selectedRow?.idleDisplayMode || "1",
      groupCallHost: props.selectedRow?.groupCallHost || false,
      groupCallGuest: props.selectedRow?.groupCallGuest || false,
      callbackEnabled: props.selectedRow?.callbackEnabled || false,
      feedbackEnabled: props.selectedRow?.feedbackEnabled || false,
    },
    validationSchema: Yup.object({
      newClientName: Yup.string().trim()
        .min(4, props.t("Too short"))
        .matches(
          /^[a-zA-Z0-9\s\-()!?&.,+#äöåøæÄÖÅÆØ]*$/,
          props.t("ContainsNotAllowedCharacters")
        ),
    }),
    onSubmit: values => {
      //console.log("Submit values: ", values)
      setClientSuccess("")
      setClientError("")
      setClientUpdate(true)
      updateVideoClient(
        abortRef.current,
        values.roomName,
        values.newClientPassword,
        values.newClientName,
        values.callbackEnabled,
        values.feedbackEnabled,
        values.groupCallHost,
        values.groupCallGuest,
        Number.parseInt(values.idleDisplayMode, 10),
        Number.parseInt(values.callRequestTimeout, 10)
      )
        .then(result => {
          console.log(result)
          if (result.statusCode == 200) {
            setClientSuccess("Updated")
            props.getRooms()
          } else {
            setClientError("Error")
            if (result.statusMessage) {
              setClientError("" + result.statusMessage)
            }
          }
        })
        .catch(err => {
          console.log(err)
          setClientError("Error")
        })
        .finally(() => {
          setClientUpdate(false)
        })
    },
  })

  const roomValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: "",
      orderNumber: props.selectedRow?.orderNumber || "",
      stage: props.selectedRow?.stage,
      remarks: props.selectedRow?.remarks || "",
    },
    validationSchema: Yup.object({}),
    onSubmit: values => {
      let temp = structuredClone(values)
      if (values.password.length > 0) temp.password = values.password
      temp.orderNumber = values.orderNumber ? values.orderNumber : ""
      console.log("Submit values: ", temp)

      setUpdateSuccess("")
      setUpdateError("")
      setUpdate(true)
      updateVideoRoom(abortRef.current, props.selectedRow.roomName, temp)
        .then(result => {
          console.log(result)
          setUpdate(false)
          setUpdateSuccess("Updated")
          props.getRooms()
        })
        .catch(err => {
          console.log(err)
          setUpdate(false)
          setUpdateError("Error")
        })
    },
  })

  // Force client refresh
  const forceRefreshClient = () => {
    setRefreshOngoing(true)
    videoForceRefresh(abortRef.current, props.selectedRow.roomName)
      .then(result => {
        console.log(result)
        showToast(props.t("Sent"), "success")
        setRefreshOngoing(false)
        //props.getRooms()
      })
      .catch(err => {
        console.log(err)
        showToast(props.t("Error"), "error")
        setRefreshOngoing(false)
      })
  }

  // Force client refresh
  const getClientStatus = () => {
    setStatusOngoing(true)
    videoGetClientStatus(abortRef.current, props.selectedRow.roomName)
      .then(result => {
        console.log(result)
        showToast(props.t("Sent"), "success")
        setStatusOngoing(false)
        props.getRooms()
      })
      .catch(err => {
        console.log(err)
        showToast(props.t("Error"), "error")
        setStatusOngoing(false)
      })
  }

  // Delete room
  const deleteRoom = () => {
    if (
      props.selectedRow.roomName != null &&
      props.selectedRow.roomName.length > 0
    ) {
      setOngoingDelete(true)
      deleteVideoClient(abortRef.current, props.selectedRow.roomName)
        .then(result => {
          if (result.statusCode === 200) {
            setDeleteModal(false)
            showToast(props.t("Deleted"), "success")

            if (result.statusMessage) {
              showToast(props.t(result.statusMessage), "info", 15000)
            }

            props.getRooms()
            props.setShowDrawer(false)
          } else {
            showToast(props.t("Error"), "error")
          }
          setOngoingDelete(false)
        })
        .catch(err => {
          showToast(props.t("Error"), "error")
          setOngoingDelete(false)
        })
    }
  }

  return (
    <>
      <Drawer
        rootClassName="custom"
        title={props.t("Video number") + " " + props.selectedRow?.roomName}
        //width={1200}
        //width={"80%"}
        placement="right"
        onClose={() => {
          props.setShowDrawer(false)
          setClientError("")
          setClientSuccess("")
          setUpdateError("")
          setUpdateSuccess("")
        }}
        open={props.showDrawer}
        zIndex={1003}
      //bodyStyle={{ backgroundColor: "#f8f8f8" }}
      >
        <Row xs={1}>
          <Col>
            <Card>
              <CardBody>
                <CardTitle className="mb-4">
                  {props.t("Video number settings")}
                </CardTitle>
                <Form
                  className="form-horizontal"
                  onSubmit={e => {
                    e.preventDefault()
                    return false
                  }}
                >
                  <Row xs={1} md={2}>
                    <Col>
                      <FormGroup>
                        <Label>{props.t("Name")}</Label>
                        <AntdForm.Item validateStatus={clientValidation.errors.newClientName ? "error" : ""} hasFeedback help={clientValidation.errors.newClientName}>
                          <AntdInput
                            allowClear
                            placeholder={props.t("Name")}
                            value={clientValidation.values.newClientName}
                            onChange={(v) => { clientValidation.setFieldValue("newClientName", v.target.value) }}
                          />
                        </AntdForm.Item>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label>{props.t("New password")}</Label>
                        <AntdInput
                          allowClear
                          placeholder={props.t("New password")}
                          value={clientValidation.values.newClientPassword}
                          onChange={(v) => { clientValidation.setFieldValue("newClientPassword", v.target.value) }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row xs={1} md={2}>
                    <Col>
                      <FormGroup>
                        <Label>{props.t("Call request timeout")}</Label>
                        <InputNumber
                          value={clientValidation.values.callRequestTimeout}
                          suffix={props.t("seconds")}
                          style={{ width: "100%" }}
                          onChange={(v) => { clientValidation.setFieldValue("callRequestTimeout", v) }}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label>{props.t("Idle display")}</Label>
                        <Select
                          value={"" + clientValidation.values.idleDisplayMode}
                          placeholder={props.t("Choose")}
                          onChange={(v) => { clientValidation.setFieldValue("idleDisplayMode", v) }}
                          options={[
                            { label: props.t("Default"), value: "1" },
                            { label: props.t("Show navigation"), value: "2" },
                            { label: props.t("Hide all"), value: "3" },
                            { label: props.t("Hide buttons"), value: "4" },
                            { label: props.t("Hide local video"), value: "5" },

                          ]}
                          style={{ width: 100 + "%" }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row xs={1} md={2}>
                    <Col>
                      <FormGroup className="mt-2">
                        <Switch
                          className="me-2"
                          name="groupCallHost"
                          checked={clientValidation.values.groupCallHost}
                          onChange={v =>
                            clientValidation.setFieldValue("groupCallHost", v)
                          }
                        ></Switch>
                        <Label>{props.t("Group host")}</Label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="mt-2">
                        <Switch
                          className="me-2"
                          name="groupCallGuest"
                          checked={clientValidation.values.groupCallGuest}
                          onChange={v =>
                            clientValidation.setFieldValue("groupCallGuest", v)
                          }
                        ></Switch>
                        <Label>{props.t("Group guest")}</Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row xs={1} md={2}>
                    <Col>
                      <FormGroup className="mt-2">
                        <Switch
                          className="me-2"
                          name="callbackEnabled"
                          checked={clientValidation.values.callbackEnabled}
                          onChange={v =>
                            clientValidation.setFieldValue("callbackEnabled", v)
                          }
                        ></Switch>
                        <Label>{props.t("Callback")}</Label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="mt-2">
                        <Switch
                          className="me-2"
                          name="feedbackEnabled"
                          checked={clientValidation.values.feedbackEnabled}
                          onChange={v =>
                            clientValidation.setFieldValue("feedbackEnabled", v)
                          }
                        ></Switch>
                        <Label>{props.t("Feedback")}</Label>
                      </FormGroup>
                    </Col>
                  </Row>

                  <div className="mt-2 mb-3 d-flex justify-content-center">
                    <Button
                      color="primary"
                      disabled={
                        !props.selectedRow?.clientPassword || clientUpdate
                      }
                      style={{ minWidth: "150px" }}
                      onClick={() => {
                        clientValidation.submitForm()
                      }}
                    >
                      {props.t("Save")}
                    </Button>
                  </div>
                  {!props.selectedRow?.clientPassword && (
                    <Alert color="danger">{props.t("Unknown password")}</Alert>
                  )}
                  {clientError ? (
                    <Alert color="danger">{props.t(clientError)}</Alert>
                  ) : null}
                  {clientSuccess ? (
                    <Alert color="success">{props.t(clientSuccess)}</Alert>
                  ) : null}
                </Form>
              </CardBody>
            </Card>
          </Col>
          <Col>
            <Card>
              <CardBody>
                <CardTitle className="mb-4">
                  {props.t("Other information")}
                </CardTitle>
                <Form
                  className="form-horizontal"
                  onSubmit={e => {
                    e.preventDefault()
                    return false
                  }}
                >
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label>{props.t("Order number")}</Label>
                        <SelectOrder
                          selection={roomValidation.values.orderNumber}
                          setSelectedOrder={(v) => { roomValidation.setFieldValue("orderNumber", v) }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row xs={1}>
                    <Col>
                      <FormGroup>
                        <Label>{props.t("Password")}</Label>
                        <AntdInput
                          allowClear
                          placeholder={props.t("Must match password set in AC portal")}
                          value={roomValidation.values.password}
                          onChange={(v) => { roomValidation.setFieldValue("password", v.target.value) }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label>{props.t("Remarks")}</Label>
                        <AntdForm.Item validateStatus={roomValidation.values.remarks?.length > 0 ? "error" : ""}>
                          <TextArea
                            allowClear
                            autoSize={{ minRows: 1, maxRows: 6 }}
                            value={roomValidation.values.remarks}
                            onChange={(v) => { roomValidation.setFieldValue("remarks", v.target.value) }}
                          />
                        </AntdForm.Item>
                      </FormGroup>
                    </Col>
                  </Row>

                  <div className="mt-2 mb-3 d-flex justify-content-center">
                    <Button
                      color="primary"
                      disabled={update}
                      style={{ minWidth: "150px" }}
                      onClick={() => {
                        roomValidation.submitForm()
                      }}
                    >
                      {props.t("Save")}
                    </Button>
                  </div>
                  {updateError ? (
                    <Alert color="danger">{props.t(updateError)}</Alert>
                  ) : null}
                  {updateSuccess ? (
                    <Alert color="success">{props.t(updateSuccess)}</Alert>
                  ) : null}
                </Form>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <CardTitle className="mb-4">{props.t("Actions")}</CardTitle>
                <ListGroup className="list-group-flush">
                  <ListGroupItem className="py-4">
                    <Row>
                      <Col>
                        <div>
                          <h6>{props.t("Refresh video status")}</h6>
                          <span className="text-muted">
                            {props.t("Query current video status from API")}
                          </span>
                        </div>
                      </Col>
                      <Col className="col-auto">
                        <Button
                          color="primary"
                          style={{ minWidth: "100px" }}
                          onClick={() => {
                            getClientStatus()
                          }}
                          disabled={
                            !props.selectedRow?.clientPassword || statusOngoing
                          }
                        >
                          {props.t("Send")}
                        </Button>
                      </Col>
                    </Row>
                  </ListGroupItem>
                  <ListGroupItem className="py-4">
                    <Row>
                      <Col>
                        <div>
                          <h6>{props.t("Page refresh")}</h6>
                          <span className="text-muted">
                            {props.t(
                              "Force the video client to refresh the webpage"
                            )}
                          </span>
                        </div>
                      </Col>
                      <Col className="col-auto">
                        <Button
                          color="primary"
                          style={{ minWidth: "100px" }}
                          onClick={() => {
                            forceRefreshClient()
                          }}
                          disabled={
                            !props.selectedRow?.clientPassword || refreshOngoing
                          }
                        >
                          {props.t("Refresh")}
                        </Button>
                      </Col>
                    </Row>
                  </ListGroupItem>
                  <ListGroupItem className="pb-4">
                    <Row>
                      <Col>
                        <div>
                          <h6>{props.t("Deletion")}</h6>
                          <span className="text-muted">
                            {props.t(
                              "The device and all related data will be deleted permanently"
                            )}
                          </span>
                        </div>
                      </Col>
                      <Col className="col-auto">
                        <Button
                          color="danger"
                          style={{ minWidth: "100px" }}
                          onClick={() => {
                            setDeleteModal(true)
                          }}
                        >
                          {props.t("Delete")}
                        </Button>
                      </Col>
                    </Row>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Drawer>

      <Modal
        isOpen={deleteModal}
        toggle={() => {
          setDeleteModal(!deleteModal)
        }}
        centered
      >
        <ModalHeader>{props.t("Delete confirmation")}</ModalHeader>
        <ModalBody>
          <p>
            {props.t("Are you sure you want to delete") +
              " " +
              props.selectedRow?.roomName +
              "?"}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            outline
            onClick={() => {
              setDeleteModal(false)
            }}
          >
            {props.t("Cancel")}
          </Button>
          <Button
            disabled={ongoingDelete}
            color="danger"
            onClick={() => {
              deleteRoom()
            }}
          >
            {props.t("Delete")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

VideoRoomDrawer.propTypes = {
  t: PropTypes.any,
  showDrawer: PropTypes.bool,
  setShowDrawer: PropTypes.any,
  selectedRow: PropTypes.any,
  getRooms: PropTypes.func,
}

export default withRouter(withTranslation()(VideoRoomDrawer))
